<template>
  <div>
    <page-header></page-header>
    <router-view></router-view>
  </div>
</template>


<script>
import PageHeader from './../shared/PageHeader'
import Coupons from './Coupons'
import ProductList from './products/ProductList'
import ShoppingCart from './shopping-cart/ShoppingCart'

export default {
  name: 'shop',
  components: {
    PageHeader,
    Coupons,
    ProductList,
    ShoppingCart
  }
}
</script>




// WEBPACK FOOTER //
// Shop.vue?123d3021